/** Mirror of the server's onboarding wizard schema (see api onboarding/schema). */

export type QuestionType =
  | "info"
  | "text"
  | "longtext"
  | "number"
  | "single"
  | "multi"
  | "scale"
  | "boolean"
  | "height"
  | "weight"
  | "date"
  | "medications";

export interface QuestionOption {
  value: string;
  label: string;
}

export interface Question {
  id: string;
  type: QuestionType;
  label: string;
  help?: string;
  placeholder?: string;
  options?: QuestionOption[];
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  required?: boolean;
  showIf?: { questionId: string; equals: string[] };
}

export interface WizardSection {
  id: string;
  title: string;
  intro?: string;
  questions: Question[];
}

export interface WizardSchema {
  version: number;
  sections: WizardSection[];
}

export type Answers = Record<string, unknown>;

/** Whether a question should be shown given the current answers (branching). */
export function isVisible(question: Question, answers: Answers): boolean {
  if (!question.showIf) return true;
  const actual = answers[question.showIf.questionId];
  return question.showIf.equals.includes(String(actual));
}
